var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoteIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7048 8.54679L18.7731 12.5205C17.9746 15.9524 16.3965 17.3403 13.4304 17.0551C12.9551 17.0171 12.4418 16.9316 11.8904 16.7985L10.2933 16.4182C6.32904 15.4771 5.1027 13.5187 6.03434 9.54498L6.96598 5.56175C7.15611 4.7537 7.38427 4.05021 7.66947 3.47031C8.78175 1.16973 10.6736 0.551808 13.8487 1.30282L15.4363 1.67358C19.4196 2.60522 20.6364 4.57307 19.7048 8.54679Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.4288 17.0575C12.8394 17.4568 12.0979 17.7895 11.1948 18.0842L9.69275 18.5785C5.91869 19.7954 3.93183 18.7782 2.70548 15.0041L1.48865 11.249C0.271812 7.47491 1.2795 5.47853 5.0536 4.2617L6.55563 3.76736C6.9454 3.64377 7.31615 3.5392 7.66789 3.47266C7.3827 4.05255 7.15454 4.75604 6.96441 5.56409L6.03277 9.54733C5.10113 13.5211 6.32747 15.4794 10.2917 16.4206L11.8888 16.8008C12.4401 16.9339 12.9535 17.0195 13.4288 17.0575Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M11.1289 6.73047L15.7396 7.89977",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.1953 10.4102L12.9522 11.1136",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteIcon);
export default __webpack_public_path__ + "static/media/noteIcon.2064ce686a43dcdd38b5b5958aa360e8.svg";
export { ForwardRef as ReactComponent };